<div class="offer-container">
  <div class="offer-grid" [ngClass]="getOfferGridClass()" *ngIf="!offer.noResult">
    <!-- planType only exists on non-dynamic and quick quote quotes, because they can have more than one planType per quote request -->
    <div class="offerTerm">
      <p class="minWidth">
        {{ offer.term }} {{ offer.term === 1 ? 'Month' : 'Months' }}
      </p>
    </div>

    <div class="text-center">
      <p *ngIf="!quoteStateHelperService.isQuickQuote(this.quoteRequestState)">
          <strong>{{ productType ? productType : 'Fixed' }}</strong>
      </p>
      <p>Usage:
        <strong>{{ offer.totalConsumption | number: '1.0-0' }} {{ (utilityUOM$ | async ) }}</strong>
      </p>
    </div>
    
    <div *ngIf="user.isSupplierManagerOrSalesManager && pricingSource == pricingSourceEnum.Dynamic" class="text-center">
      <mat-form-field appearance="standard" floatLabel="always">
        <mat-label>Margin (Mills/{{ utilityUOM$ | async }})</mat-label>
        <input matInput type="number"
          [value]="marginDollar"
          (focus)="marginPreviousInput = $event?.target?.value"
          (blur)="marginPerTermChanges($event?.target, offer, $event?.target?.valueAsNumber != +marginPreviousInput)"
          [disabled]="styles(quoteState).disabled || isReadOnly || !offer.sellingPrice"
          maxlength="8" pattern="\d{1,5}(?:\.\d{1,5})?$" name="margin"/>
      </mat-form-field>
    </div>

    <div class="text-center">
      <p *ngIf="user.isSupplierManagerOrSalesManager
      && pricingSource !== pricingSourceEnum.ManualEntry
      && offer.sellingPrice">
        <strong>Total Supplier Margin:&nbsp;${{ offer.totalMargin | number: '1.2-2'}}</strong>
      </p>
      <p *ngIf="user.isSupplierManagerOrSalesManager
      && pricingSource !== pricingSourceEnum.ManualEntry
      && !offer.sellingPrice">
        <strong>Total Supplier Margin:&nbsp;N/A</strong>
      </p>
      <p *ngIf="offer.sellingPrice"><strong>Total Commission:&nbsp;${{ offer.totalCommission| number: '1.2-2'}}</strong></p>
      <p *ngIf="!offer.sellingPrice"><strong>Total Commission:&nbsp;N/A</strong></p>
      <p *ngIf="offer.term > 12 && offer.sellingPrice">Annual Commission:&nbsp;${{ offer.commissionYear | number: '1.2-2'}}</p>
      <!-- <p>{{ offer.sellingPrice * 1000 | number: '1.4-4' }}/{{ utilityUOM$ | async  }}&nbsp;x&nbsp;{{ offer.agentFee / 1000 | number: '1.2-4'}}</p> -->
      <p>Agent Fee:&nbsp;${{ this.getAgentFeeTotal() | number: '1.2-2'}}</p>
      <p *ngIf="offer.term > 12 && !offer.sellingPrice"></p>
    </div>

    <div class="text-center" *ngIf="!quoteStateHelperService.isQuickQuote(this.quoteRequestState)">
      <p *ngIf="user.isSupplierManagerOrSalesManager
              && pricingSource !== pricingSourceEnum.ManualEntry
              && offer.sellingPrice">
        <strong>Total Margin:&nbsp;${{ offer.details?.[0]?.marginPerUnit ?? 0 | number: '1.2-2'}}/MWh&nbsp;</strong>
      </p>
      <p *ngIf="user.isSupplierManagerOrSalesManager
              && pricingSource !== pricingSourceEnum.ManualEntry
              && offer.sellingPrice">
        <strong>Client Adder:&nbsp;${{ offer.details?.[0]?.clientAddersPerUnit ?? 0 | number: '1.2-2' }}/MWh&nbsp;</strong>
      </p>      
    </div>

    <div class="cost">
      <p class="ttlCost" *ngIf="!offer.sellingPrice">N/A
        <mat-icon color="accent"
        style="font-size: 1em"
        title="Indicative price per utility account - prices subject to change">info</mat-icon></p>

      <p class="ttlCost" *ngIf="offer.sellingPrice">${{ offer.totalCost | number: '1.2-2' }} Total
        <mat-icon color="accent"
        style="font-size: 1em"
        title="Indicative price per utility account - prices subject to change">info</mat-icon></p>
      <p class="per-year" *ngIf="!offer.sellingPrice">
        {{''}}
      </p>
      <p class="per-year" *ngIf="offer.term > 12  && offer.sellingPrice">
        ${{ offer.annualCost | number: '1.2-2' }}{{ '' | ratePerYear: offer.term }}
      </p>

      <p class="swtspot" *ngIf="offer.isSweetSpot && offer.sellingPrice"><em>Sweet Spot</em></p>
    </div>

    <div class="sellingPrice" >
      <p *ngIf="!offer.sellingPrice" id="null-selling-price">{{ displayStatusMessage() }}</p>
      <p *ngIf="offer.sellingPrice">${{ offer.sellingPrice | number: '1.5-5' }}/{{ utilityUOM$ | async  }}</p>

      <div id="moreDetails" class="moreDetails" *ngIf="offer.sellingPrice && pricingSource == pricingSourceEnum.Dynamic && !quoteStateHelperService.isQuickQuote(this.quoteRequestState)">
        <a (click)="showMoreDetails()"> More Details </a>
      </div>
    </div>

    <!-- Ask about quote status for disabled attribute -->
    <div class="offer-actions" [ngClass]="styles(quoteState).class" *ngIf="!quoteStateHelperService.isQuickQuote(this.quoteRequestState)">

      <button mat-flat-button color="accent" [disabled]="(isAnyMarginEdited || !offer.sellingPrice) || isReadOnly" type="button" (click)="progressOffer()"
        *ngIf="
          quoteState !== quoteStateType.PENDING_ENROLLMENT &&
          quoteState !== quoteStateType.APPROVAL_ACCEPTED &&
          quoteState !== quoteStateType.APPROVAL_REJECTED &&
          quoteState !== quoteStateType.OFFER_ACCEPTED &&
          quoteState !== quoteStateType.OFFER_REJECTED">
        <span> {{ getActionLabel() }} </span>
      </button>

      <div class="action-label">
        <mat-label *ngIf="
            quoteState === quoteStateType.PENDING_ENROLLMENT ||
            quoteState === quoteStateType.APPROVAL_ACCEPTED ||
            quoteState === quoteStateType.APPROVAL_REJECTED ||
            quoteState === quoteStateType.OFFER_ACCEPTED ||
            quoteState === quoteStateType.OFFER_REJECTED">
          <mat-icon class="action-icon" [svgIcon]="styles(quoteState).icon" matPrefix></mat-icon>
          {{ this.getActionLabel() }}
          <div class="loading-spinner" *ngIf="this.loading">
            <mat-spinner [diameter]="15"></mat-spinner>
          </div>
        </mat-label>
      </div>
    </div>
  </div>
  <div *ngIf="offer.noResult">
    <div class="no-prices">-- No price available for {{ offer.term }} month contract length --</div>
  </div>
</div>
